<template>
  <v-sheet border rounded class="d-inline-block">
    <div class="text-center mb-1">
      <strong>{{ title }}</strong>
      <v-tooltip>
        <template #activator="{ props }">
          <v-icon end icon="mdi-information-outline" v-bind="props" />
        </template>
        <div>{{ description }}</div>
      </v-tooltip>
    </div>

    <v-divider />

    <v-btn-toggle
      :model-value="modelValue"
      density="compact"
      divided
      tile
      mandatory
      @update:model-value="emit('update:modelValue', $event)"
    >
      <template v-for="item in items">
        <v-btn v-if="item.count" :key="item.value" :value="item.value">
          {{ item.label }}
          <v-badge v-if="item.count" :content="item.count" inline bordered :color="color(item)" />
        </v-btn>
      </template>
    </v-btn-toggle>
  </v-sheet>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const color = (item) => (item.value === 'all' ? 'grey-lighten-2' : item.color + '-lighten-5')
</script>

<style scoped lang="scss">
strong {
  font-size: 1.4em;
}
</style>
